import React from 'react';
import ReactImageZoom from 'react-image-zoom';
 
const props = {};
class ImageZoom extends React.Component{
    state = {
        image: this.props.image,
        height: window.innerHeight-279,
        width: ""
    }
    componentDidMount(){
        console.log(this.props);
        this.setState({
            image: this.props.image,
            height: window.innerHeight-279,
        });
        window.addEventListener("resize", () => {
            this.setState({
                height: window.innerHeight-279,
            })
        });
        console.log(navigator.userAgent)
        navigator.userAgent.includes('Macintosh') ? this.setState({
            width: window.innerHeight-279
        }) : this.setState({
            width: ""
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => {
            this.setState({
                height: window.innerHeight-279,
            })
        });
    }

    render() {
        return (
            <span style={{width:"auto",height: "calc(100vh - 279px)",objectFit:"scale-down"}} id="zoom-image"
            >
                {(this.props.image != undefined) ?
                <ReactImageZoom
                    img={this.props.image}
                    imageStyle={{objectFit:"scale-down"}}
                    width={this.state.width}
                    style={{width:"auto",objectFit:"scale-down"}}
                    height={window.innerHeight-279}
                    zoomPosition="original"
                />
                :
                ""
                }
            </span>
        );
    }
}

export default ImageZoom;